// extracted by mini-css-extract-plugin
export default {"srOnly":"input-module__srOnly___opDW5 common-module__screenReaderOnly___uPhYo"};